export default async () => {
	// lets give the body a store-locator class
	document.querySelector("body").classList.add("store-locator");

	await waitFor((_) => getFilters().length > 0);
	let filters = getFilters();

	// we just need to add ids to the filters so that we can manipulate them with css
	filters.forEach((filter) => {
		filter.id = filter.innerText.replace(" ", "-").toLowerCase();
	});
};

// get filters
const getFilters = () => {
	let filters = document.querySelectorAll("#categories_filter .multiselect-container.adropdown-menu li");

	if (filters.length == 0) {
		setTimeout(() => {
			getFilters();
		}, 1000);
	}

	return filters;
};

function waitFor(conditionFunction) {
	const poll = (resolve) => {
		if (conditionFunction()) resolve();
		else setTimeout((_) => poll(resolve), 400);
	};

	return new Promise(poll);
}
